webpackJsonp([229884840450167],{

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/transient_recorders.0805c2b9.png";

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Hero = __webpack_require__(8);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ProductCard = __webpack_require__(13);
	
	var _ProductCard2 = _interopRequireDefault(_ProductCard);
	
	var _LazyLoad = __webpack_require__(10);
	
	var _LazyLoad2 = _interopRequireDefault(_LazyLoad);
	
	var _transient_recorders = __webpack_require__(706);
	
	var _transient_recorders2 = _interopRequireDefault(_transient_recorders);
	
	var _productsData = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var heroData = {
	    heroTitle: ['transient', 'recorders'],
	    heroImg: _transient_recorders2.default,
	    heroDescHtml: 'Precision measurement of torque, angle, load cell, and pressure is provided in the Standard MC900.It is a valuable tool for fastener enineers to study threaded fastener joint designs or they can analyze the operation of nut-runners on the plant floor and in a labratory environment.',
	    breadcrumbs: {
	        text: 'home',
	        link: '/',
	
	        path: {
	            text: 'transient recorders',
	            link: 'transient-recorders'
	        }
	    }
	};
	
	var productList = _productsData.productsData.filter(function (data) {
	    return data.category.toLowerCase() === heroData.breadcrumbs.path.text.toLowerCase();
	});
	
	var TransientRecorders = function TransientRecorders() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'o-sub' },
	        _react2.default.createElement(_Hero2.default, { heroData: heroData }),
	        _react2.default.createElement(
	            'div',
	            { className: 'o-container' },
	            _react2.default.createElement(
	                _LazyLoad2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'c-products-list ' + (productList[0] && productList[0].items.length >= 2 ? '' : 'c-products-list--simple') },
	                    productList[0] && productList[0].items.map(function (product, i) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'c-products-list__item', key: i },
	                            _react2.default.createElement(_ProductCard2.default, { product: product })
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	exports.default = TransientRecorders;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-transient-recorders-index-jsx-492a4b10c3faa6583164.js